const updatingIcon = require('assets/icons/tink-aggregation-updating.svg');
const errorIcon = require('assets/icons/tink-aggregation-error.svg');
const koIcon = require('assets/icons/tink-aggregation-ko.svg');

module.exports = {
  UPDATED: 'UPDATED',
  UPDATING: 'UPDATING',
  DELETED: 'DELETED',
  AUTHENTICATING: 'AUTHENTICATING',
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  TEMPORARY_ERROR: 'TEMPORARY_ERROR',
  AWAITING_SUPPLEMENTAL_INFORMATION: 'AWAITING_SUPPLEMENTAL_INFORMATION',
  AWAITING_MOBILE_BANKID_AUTHENTICATION: 'AWAITING_MOBILE_BANKID_AUTHENTICATION',
  AWAITING_THIRD_PARTY_APP_AUTHENTICATION: 'AWAITING_THIRD_PARTY_APP_AUTHENTICATION',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  //MULTIPLE_ERROR: 'MULTIPLE_ERROR',
  MESSAGES_STATUSES: [
    {
      NAME: 'TEMPORARY_ERROR',
      ICON: errorIcon,
      TITLE: 'aggregatorStatus-koTitle',
      DESCRIPTION: 'aggregatorStatus-koDescription',
    },
    {
      NAME: 'UPDATING',
      TITLE: 'aggregatorStatus-pendingTitle',
      DESCRIPTION: 'aggregatorStatus-pendingDescription',
      ICON: updatingIcon,
    },
    {
      NAME: 'AUTHENTICATING',
      TITLE: 'aggregatorStatus-syncTitle',
      DESCRIPTION: 'aggregatorStatus-syncDescription',
    },
    {
      NAME: 'AUTHENTICATION_ERROR',
      ICON: errorIcon,
      TITLE: 'aggregatorStatus-badCredentialsTitle',
      DESCRIPTION: 'aggregatorStatus-badCredentialsDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-badCredentialsPrimaryButton',
      URL: '/myprofile/global/entities/credentials/',
    },
    {
      NAME: 'AWAITING_SUPPLEMENTAL_INFORMATION',
      ICON: errorIcon,
      TITLE: 'aggregatorStatus-secondFactorAuthTitle',
      DESCRIPTION: 'aggregatorStatus-secondFactorAuthDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-secondFactorAuthPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-secondFactorAuthSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'AWAITING_MOBILE_BANKID_AUTHENTICATION',
      ICON: errorIcon,
      TITLE: 'aggregatorStatus-secondFactorAuthTitle',
      DESCRIPTION: 'aggregatorStatus-secondFactorAuthDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-secondFactorAuthPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-secondFactorAuthSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'AWAITING_THIRD_PARTY_APP_AUTHENTICATION',
      ICON: errorIcon,
      TITLE: 'aggregatorStatus-secondFactorAuthTitle',
      DESCRIPTION: 'aggregatorStatus-secondFactorAuthDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-secondFactorAuthPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-secondFactorAuthSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'SESSION_EXPIRED',
      ICON: koIcon,
      TITLE: 'aggregatorStatus-sessionExpiredTitle',
      DESCRIPTION: 'aggregatorStatus-sessionExpiredDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-sessionExpiredPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-secondFactorAuthSecondButton',
      URL: '/myprofile/global/entities/add/credentials/',
    },
    {
      NAME: 'MULTIPLE_PENDING', // Exclusive to show on GP view
      ICON: updatingIcon,
      TITLE: 'aggregatorStatus-multiplePendingTitle',
      DESCRIPTION: 'aggregatorStatus-multiplePendingDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-multiplePendingPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-multiplePendingSecondButton',
      INFO: 'aggregatorStatus-pendingDescription',
    },
    /*
    // NOT AVAILABLE YET
    {
      NAME: 'MULTIPLE_ERROR', // Exclusive to show on GP view
      ICON: errorIcon,
      NOPOEDITOR: true,
      TITLE: 'aggregatorStatus-secondFactorAuthTitle',
      DESCRIPTION: 'aggregatorStatus-secondFactorAuthDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-sessionExpiredPrimaryButton',
    },
    */
    // NO HAY EQUIVALENCIA EN TINK
    {
      NAME: 'EXPIRED_SECOND_FACTOR_AUTHENTICATION',
      TITLE: 'aggregatorStatus-expiredSecondFactorTitle',
      DESCRIPTION: 'aggregatorStatus-expiredSecondFactorDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-expiredSecondFactorPrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-expiredSecondFactorSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'SECOND_FACTOR_AUTHENTICATION_APP_CONFIRMATION',
      TITLE: 'aggregatorStatus-secondFactorAuthenticationAppConfirmationTitle',
      DESCRIPTION: 'aggregatorStatus-secondFactorAuthenticationAppConfirmationDescription',
    },
    {
      NAME: 'BAD_SECOND_FACTOR_AUTHENTICATION',
      TITLE: 'aggregatorStatus-badSecondPhaseTitle',
      DESCRIPTION: 'aggregatorStatus-badSecondPhaseDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-badSecondPhasePrimaryButton',
      TEXT_SECOND_BUTTON: 'aggregatorStatus-expiredSecondFactorSecondButton',
      URL: '/myprofile/global/entities/manage/credentials/',
    },
    {
      NAME: 'PSD2_SESSION_EXPIRED',
      TITLE: 'aggregatorStatus-sessionExpiredTitle',
      DESCRIPTION: 'aggregatorStatus-sessionExpiredDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-sessionExpiredPrimaryButton',
      URL: '/myprofile/global/entities/add/credentials/',
    },
    {
      NAME: 'PENDING_SCRAPING_CREDENTIALS',
      TITLE: 'aggregatorStatus-pendingScrapingCredentialsTitle',
      DESCRIPTION: 'aggregatorStatus-pendingScrapingCredentialsDescription',
      TEXT_PRIMARY_BUTTON: 'aggregatorStatus-pendingScrapingCredentialsPrimaryButton',
      URL: '/myprofile/global/entities/add/credentials/scrapping/',
    },
  ],
};
